/**
 * Given an array of data points, a category, a subcategory, and a subdivision,
 * returns data points matching the specified filter.
 * @param {Array} data - An array of data point objects to filter.
 * @param {string|null} category - The category to match against.
 * @param {string|null} subcategory - The subcategory to match against.
 * @param {string|null} subdivision - The subdivision to match against.
 * @returns {Array} The filtered array.
 */
const filterData = (data, category, subcategory, subdivision) => data
  .filter((datum) => datum.category === category
    && datum.subcategory === subcategory
    && datum.subdivision === subdivision);

export default filterData;
